(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('solicitationsLast', SolicitationsLast)

    /** @ngInject */
    function SolicitationsLast($rootScope, HelperService, AuthenticationService, HelpdeskService, PATHS, DATA_EVENTS) {
        function SolicitationsLastController($scope) {
            const vm = this;

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            init();

            function getArtsSolicitations() {
                HelperService.startLoading('.last-elements.arts');

                let userData = AuthenticationService.getUserData();
                vm.isLoading = true;

                HelpdeskService
                    .getAllByParameters({
                        PerPage: 4,
                        Skip: 0,
                        OrderBy: 'RegistrationDate',
                        OrderDescending: true,
                        IsArtsSolicitation: true
                    }, userData.Id)
                    .then(success => {
                        vm.artsSolicitations = success.Ticket;

                        for (let index = 0; index < vm.artsSolicitations.length; index++) {
                            vm.artsSolicitations[index].LastResponse = vm.artsSolicitations[index].TicketTimeline[vm.artsSolicitations[index].TicketTimeline.length - 1];
                        }

                        vm.isLoading = false;
                        HelperService.stopLoading('.last-elements.arts');
                    }, error => {
                        vm.isLoading = false;
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.last-elements.arts');
                    })
            }

            function init() {
                vm.isLoading = true;
                vm.artsSolicitations = [];

                getArtsSolicitations();
            }
        }

        return {
            bindToController: true,
            controller: SolicitationsLastController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/solicitations-last/solicitations-last.html`,
            scope: {}
        }
    }
}());